// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"4f2dd946","455":"4fbef3b2","977":"5abb58de"}[chunkId] + ".chunk.js";
};